module.exports = __webpack_public_path__ + "media/images/featured-ebc8f5f2241faeab43b7a4afe442b6ed.jpg";